import { render, staticRenderFns } from "./ArtPerfOrigin.vue?vue&type=template&id=61b37a17&"
import script from "./ArtPerfOrigin.vue?vue&type=script&lang=ts&"
export * from "./ArtPerfOrigin.vue?vue&type=script&lang=ts&"
import style0 from "./ArtPerfOrigin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports